const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL || 'https://admail.online/be/api/',
};

export default config;


